
// // src/components/settings/CompanySettingsForm.jsx
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { toast } from "react-toastify"; // Install: npm install react-toastify
// import CompanySettingsTabs from "./CompanySettingsTabs";

//  const API_BASE = "http://localhost:4000/api/company-settings"; // Matches your backend mount
// //const API_BASE = "https://api.onedesk.digital/api/company-settings";
// export default function CompanySettingsForm() {
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [companyId, setCompanyId] = useState(null);
//   const [formData, setFormData] = useState({
//     // Company fields
//     legal_name: "",
//     trade_name: "",
//     address: "",
//     shipping_address: "",
//     pincode: "",
//     state: "",
//     primary_phone: "",
//     alternate_phone: "",
//     landline: "",
//     primary_email: "",
//     support_email: "",
//     accounts_email: "",
//     website: "",
//     gstin: "",
//     pan: "",
//     tan: "",
//     cin: "",
//     iec: "",
//     msme_udyam: "",
//     iso_number: "",
//     extra_registrations: {},
//     enable_gstin: true,
//     enable_pan: true,
//     enable_tan: false,
//     enable_cin: false,
//     enable_iec: false,
//     enable_msme: false,
//     enable_iso: false,

//     // Settings fields
//     invoice_prefix: "INV",
//     quotation_prefix: "QTN",
//     purchase_order_prefix: "PO",
//     default_currency: "INR",
//     tax_label: "GST",
//     default_tax_rate: 18.00,
//     enable_gst: true,
//     financial_year_start_month: 4,
//     low_stock_threshold: 10,
//     enable_notifications: true,
//     logo_primary: null,       // preview URL or file object
//     letterhead_file: null,
//     upi_qr_code: null,
//   });

//   // Fetch settings on mount
//   useEffect(() => {
//     fetchSettings();
//   }, []);


// const fetchSettings = async () => {
//   try {
//     setLoading(true);
//     const token = localStorage.getItem("token");
//     if (!token) {
//       toast.error("Please login first");
//       return;
//     }

//     const res = await axios.get(`${API_BASE}/`, {  // ← use / for current user
//       headers: { Authorization: `Bearer ${token}` },
//     });

//     const data = res.data;
//     const settings = data.settings || {};
//     const company = data.Company || {};

//     setCompanyId(settings.company_id || company.id);

//     setFormData({
//       // Company fields
//       legal_name: company.legal_name || "",
//       trade_name: company.trade_name || "",
//       address: company.address || "",
//       shipping_address: company.shipping_address || "",
//       pincode: company.pincode || "",
//       state: company.state || "",
//       primary_phone: company.primary_phone || "",
//       alternate_phone: company.alternate_phone || "",
//       landline: company.landline || "",
//       primary_email: company.primary_email || "",
//       support_email: company.support_email || "",
//       accounts_email: company.accounts_email || "",
//       website: company.website || "",
//       gstin: company.gstin || "",
//       pan: company.pan || "",
//       tan: company.tan || "",
//       cin: company.cin || "",
//       iec: company.iec || "",
//       msme_udyam: company.msme_udyam || "",
//       iso_number: company.iso_number || "",
//       extra_registrations: company.extra_registrations || {},
//       enable_gstin: company.enable_gstin ?? true,
//       enable_pan: company.enable_pan ?? true,
//       enable_tan: company.enable_tan ?? false,
//       enable_cin: company.enable_cin ?? false,
//       enable_iec: company.enable_iec ?? false,
//       enable_msme: company.enable_msme ?? false,
//       enable_iso: company.enable_iso ?? false,

//       // Settings fields
//       invoice_prefix: settings.invoice_prefix || "INV",
//       quotation_prefix: settings.quotation_prefix || "QTN",
//       purchase_order_prefix: settings.purchase_order_prefix || "PO",
//       default_currency: settings.default_currency || "INR",
//       tax_label: settings.tax_label || "GST",
//       default_tax_rate: settings.default_tax_rate || 18.00,
//       enable_gst: settings.enable_gst ?? true,
//       financial_year_start_month: settings.financial_year_start_month || 4,
//       low_stock_threshold: settings.low_stock_threshold || 10,
//       enable_notifications: settings.enable_notifications ?? true,
//       logo_primary: company.logo_primary || settings.logo_primary || null,
//       letterhead_file: settings.letterhead_file || null,
//       upi_qr_code: settings.upi_qr_code || null,
//     });

//     toast.success("Settings loaded successfully");
//   } catch (err) {
//     console.error("Fetch settings error:", err);
//     toast.error(err.response?.data?.message || "Failed to load settings");
//   } finally {
//     setLoading(false);
//   }
// };
//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleFileChange = (e) => {
//     const { name, files } = e.target;
//     if (files && files[0]) {
//       setFormData((prev) => ({
//         ...prev,
//         [name]: files[0], // store File object for upload
//       }));
//     }
//   };
//   const handleSubmit = async (e) => {
//   e.preventDefault();
//   setSaving(true);

//   try {
//     const token = localStorage.getItem("token");
//     if (!token) throw new Error("No authentication token found");

//     const formDataToSend = new FormData();

//     // Append all text/boolean/number fields
//     Object.entries(formData).forEach(([key, value]) => {
//       if (value !== null && value !== undefined && typeof value !== "object") {
//         formDataToSend.append(key, value);
//       }
//     });

//     // Append files only if new File objects
//     if (formData.logo_primary instanceof File) {
//       formDataToSend.append("logo_primary", formData.logo_primary);
//     }
//     if (formData.letterhead_file instanceof File) {
//       formDataToSend.append("letterhead_file", formData.letterhead_file);
//     }
//     if (formData.upi_qr_code instanceof File) {
//       formDataToSend.append("upi_qr_code", formData.upi_qr_code);
//     }

//     // Correct URL: no extra "/settings"
//     const url = companyId
//       ? `${API_BASE}/${companyId}`          // e.g. /api/company-settings/32
//       : `${API_BASE}/`;                     // e.g. /api/company-settings/

//     console.log("Saving to URL:", url);  // ← add this for debug

//     const res = await axios.put(url, formDataToSend, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "multipart/form-data",
//       },
//     });

//     toast.success("Settings updated successfully!");
//     fetchSettings(); // Refresh form
//   } catch (err) {
//     console.error("Update settings error:", err);
//     toast.error(err.response?.data?.message || "Failed to save settings");
//   } finally {
//     setSaving(false);
//   }
// };



//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
//       <CompanySettingsTabs
//         formData={formData}
//         handleChange={handleChange}
//         handleFileChange={handleFileChange}
//         saving={saving}
//         onSubmit={handleSubmit}
//       />
//     </div>
//   );
// }

// src/components/settings/CompanySettingsForm.jsx
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import api from "../../utils/api"; // adjust path according to your folder structure
import CompanySettingsTabs from "./CompanySettingsTabs";

export default function CompanySettingsForm() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [companyId, setCompanyId] = useState(null);

  const [formData, setFormData] = useState({
    legal_name: "",
    trade_name: "",
    address: "",
    shipping_address: "",
    pincode: "",
    state: "",
    primary_phone: "",
    alternate_phone: "",
    landline: "",
    primary_email: "",
    support_email: "",
    accounts_email: "",
    website: "",
    gstin: "",
    pan: "",
    tan: "",
    cin: "",
    iec: "",
    msme_udyam: "",
    iso_number: "",
    extra_registrations: {},
    enable_gstin: true,
    enable_pan: true,
    enable_tan: false,
    enable_cin: false,
    enable_iec: false,
    enable_msme: false,
    enable_iso: false,
    invoice_prefix: "INV",
    quotation_prefix: "QTN",
    purchase_order_prefix: "PO",
    default_currency: "INR",
    tax_label: "GST",
    default_tax_rate: 18.00,
    enable_gst: true,
    financial_year_start_month: 4,
    low_stock_threshold: 10,
    enable_notifications: true,
    logo_primary: null,     // will be string (URL) or File
    letterhead_file: null,
    upi_qr_code: null,
  });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const res = await api.get("/company-settings");

      const data = res.data;
      const settings = data.settings || {};
      const company = data.Company || {};

      setCompanyId(settings.company_id || company.id || null);

      setFormData((prev) => ({
        ...prev,
        legal_name: company.legal_name || "",
        trade_name: company.trade_name || "",
        address: company.address || "",
        shipping_address: company.shipping_address || "",
        pincode: company.pincode || "",
        state: company.state || "",
        primary_phone: company.primary_phone || "",
        alternate_phone: company.alternate_phone || "",
        landline: company.landline || "",
        primary_email: company.primary_email || "",
        support_email: company.support_email || "",
        accounts_email: company.accounts_email || "",
        website: company.website || "",
        gstin: company.gstin || "",
        pan: company.pan || "",
        tan: company.tan || "",
        cin: company.cin || "",
        iec: company.iec || "",
        msme_udyam: company.msme_udyam || "",
        iso_number: company.iso_number || "",
        extra_registrations: company.extra_registrations || {},
        enable_gstin: company.enable_gstin ?? true,
        enable_pan: company.enable_pan ?? true,
        enable_tan: company.enable_tan ?? false,
        enable_cin: company.enable_cin ?? false,
        enable_iec: company.enable_iec ?? false,
        enable_msme: company.enable_msme ?? false,
        enable_iso: company.enable_iso ?? false,
        invoice_prefix: settings.invoice_prefix || "INV",
        quotation_prefix: settings.quotation_prefix || "QTN",
        purchase_order_prefix: settings.purchase_order_prefix || "PO",
        default_currency: settings.default_currency || "INR",
        tax_label: settings.tax_label || "GST",
        default_tax_rate: settings.default_tax_rate || 18.00,
        enable_gst: settings.enable_gst ?? true,
        financial_year_start_month: settings.financial_year_start_month || 4,
        low_stock_threshold: settings.low_stock_threshold || 10,
        enable_notifications: settings.enable_notifications ?? true,
        logo_primary: company.logo_primary || null,
        letterhead_file: settings.letterhead_file || null,
        upi_qr_code: settings.upi_qr_code || null,
      }));

      toast.success("Settings loaded successfully");
    } catch (err) {
      console.error("Fetch settings error:", err);
      toast.error(err.response?.data?.message || "Failed to load settings");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files?.[0]) {
      setFormData((prev) => ({
        ...prev,
        [name]: files[0],
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const payload = new FormData();

      // Append all non-object fields
      Object.entries(formData).forEach(([key, value]) => {
        if (value != null && typeof value !== "object") {
          payload.append(key, value);
        }
      });

      // Append files only if they are newly selected File objects
      if (formData.logo_primary instanceof File) {
        payload.append("logo_primary", formData.logo_primary);
      }
      if (formData.letterhead_file instanceof File) {
        payload.append("letterhead_file", formData.letterhead_file);
      }
      if (formData.upi_qr_code instanceof File) {
        payload.append("upi_qr_code", formData.upi_qr_code);
      }

      if (companyId) {
        await api.put(`/company-settings/${companyId}`, payload);
      } else {
        await api.post("/company-settings", payload);
      }

      toast.success("Settings updated successfully!");
      await fetchSettings(); // refresh displayed values & image URLs
    } catch (err) {
      console.error("Save settings error:", err);
      toast.error(err.response?.data?.message || "Failed to save settings");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500"></div>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
      <CompanySettingsTabs
        formData={formData}
        handleChange={handleChange}
        handleFileChange={handleFileChange}
        saving={saving}
        onSubmit={handleSubmit}
      />
    </div>
  );
}

// // src/components/settings/CompanySettingsForm.jsx
// import React, { useState, useEffect } from "react";
// import { toast } from "react-toastify";
// import api from "../../utils/api"; // adjust path
// import CompanySettingsTabs from "./CompanySettingsTabs";

// export default function CompanySettingsForm() {
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [companyId, setCompanyId] = useState(null);
//   const [formData, setFormData] = useState({
//     legal_name: "",
//     trade_name: "",
//     address: "",
//     shipping_address: "",
//     pincode: "",
//     state: "",
//     primary_phone: "",
//     alternate_phone: "",
//     landline: "",
//     primary_email: "",
//     support_email: "",
//     accounts_email: "",
//     website: "",
//     gstin: "",
//     pan: "",
//     tan: "",
//     cin: "",
//     iec: "",
//     msme_udyam: "",
//     iso_number: "",
//     extra_registrations: {},
//     enable_gstin: true,
//     enable_pan: true,
//     enable_tan: false,
//     enable_cin: false,
//     enable_iec: false,
//     enable_msme: false,
//     enable_iso: false,
//     invoice_prefix: "INV",
//     quotation_prefix: "QTN",
//     purchase_order_prefix: "PO",
//     default_currency: "INR",
//     tax_label: "GST",
//     default_tax_rate: 18.00,
//     enable_gst: true,
//     financial_year_start_month: 4,
//     low_stock_threshold: 10,
//     enable_notifications: true,
//     logo_primary: null, // string (url) or File
//     logo_secondary: null, // Add this for secondary logo
//     letterhead_file: null,
//     upi_qr_code: null,
//     company_code: "", // Add this if used in UI
//     is_active: true, // Add this if used in UI
//   });

//   useEffect(() => {
//     fetchSettings();
//   }, []);

//   const fetchSettings = async () => {
//     try {
//       setLoading(true);
//       const res = await api.get("/company-settings"); // relative path
//       const data = res.data;
//       const settings = data.settings || {};
//       const company = data.Company || {};
//       setCompanyId(settings.company_id || company.id || null);
//       setFormData((prev) => ({
//         ...prev,
//         legal_name: company.legal_name || "",
//         trade_name: company.trade_name || "",
//         address: company.address || "",
//         shipping_address: company.shipping_address || "",
//         pincode: company.pincode || "",
//         state: company.state || "",
//         primary_phone: company.primary_phone || "",
//         alternate_phone: company.alternate_phone || "",
//         landline: company.landline || "",
//         primary_email: company.primary_email || "",
//         support_email: company.support_email || "",
//         accounts_email: company.accounts_email || "",
//         website: company.website || "",
//         gstin: company.gstin || "",
//         pan: company.pan || "",
//         tan: company.tan || "",
//         cin: company.cin || "",
//         iec: company.iec || "",
//         msme_udyam: company.msme_udyam || "",
//         iso_number: company.iso_number || "",
//         extra_registrations: company.extra_registrations || {},
//         enable_gstin: company.enable_gstin ?? true,
//         enable_pan: company.enable_pan ?? true,
//         enable_tan: company.enable_tan ?? false,
//         enable_cin: company.enable_cin ?? false,
//         enable_iec: company.enable_iec ?? false,
//         enable_msme: company.enable_msme ?? false,
//         enable_iso: company.enable_iso ?? false,
//         invoice_prefix: settings.invoice_prefix || "INV",
//         quotation_prefix: settings.quotation_prefix || "QTN",
//         purchase_order_prefix: settings.purchase_order_prefix || "PO",
//         default_currency: settings.default_currency || "INR",
//         tax_label: settings.tax_label || "GST",
//         default_tax_rate: settings.default_tax_rate || 18.00,
//         enable_gst: settings.enable_gst ?? true,
//         financial_year_start_month: settings.financial_year_start_month || 4,
//         low_stock_threshold: settings.low_stock_threshold || 10,
//         enable_notifications: settings.enable_notifications ?? true,
//         logo_primary: company.logo_primary || null,
//         logo_secondary: company.logo_secondary || null, // Add this
//         letterhead_file: settings.letterhead_file || null,
//         upi_qr_code: settings.upi_qr_code || null,
//         company_code: company.company_code || "",
//         is_active: company.is_active ?? true,
//       }));
//       toast.success("Company settings loaded");
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Could not load settings");
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleFileChange = (e) => {
//     const { name, files } = e.target;
//     if (files?.[0]) {
//       setFormData((prev) => ({
//         ...prev,
//         [name]: files[0],
//       }));
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setSaving(true);
//     try {
//       const payload = new FormData();
//       // Non-file fields
//       Object.entries(formData).forEach(([key, val]) => {
//         if (val != null && typeof val !== "object") {
//           payload.append(key, val);
//         }
//       });
//       // Handle object fields like extra_registrations
//       payload.append("extra_registrations", JSON.stringify(formData.extra_registrations));
//       // Files — only if new upload (File instance)
//       if (formData.logo_primary instanceof File) {
//         payload.append("logo_primary", formData.logo_primary);
//       }
//       if (formData.logo_secondary instanceof File) {
//         payload.append("logo_secondary", formData.logo_secondary);
//       }
//       if (formData.letterhead_file instanceof File) {
//         payload.append("letterhead_file", formData.letterhead_file);
//       }
//       if (formData.upi_qr_code instanceof File) {
//         payload.append("upi_qr_code", formData.upi_qr_code);
//       }

//       // Debug: Log FormData contents
//       console.log("Payload entries:", [...payload.entries()]);

//       const config = {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       };

//       if (companyId) {
//         await api.put(`/company-settings/${companyId}`, payload, config);
//       } else {
//         await api.post("/company-settings", payload, config);
//       }
//       toast.success("Settings saved successfully");
//       fetchSettings(); // reload to show updated URLs etc.
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to save settings");
//       console.error(err);
//     } finally {
//       setSaving(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500"></div>
//       </div>
//     );
//   }
//   return (
//     <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
//       <CompanySettingsTabs
//         formData={formData}
//         handleChange={handleChange}
//         handleFileChange={handleFileChange}
//         saving={saving}
//         onSubmit={handleSubmit}
//       />
//     </div>
//   );
// }